import { supabase } from '../lib/supabase';

const demoLocations = [
  {
    name: "Lloyd's of London",
    model: "openmeteo",
    parameter: "temperature_2m_max",
    coordinates: [-0.085, 51.512],
    zoom: 14,
    polygon: {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [[
          [-0.11, 51.487],
          [-0.06, 51.487],
          [-0.06, 51.537],
          [-0.11, 51.537],
          [-0.11, 51.487]
        ]]
      }
    },
    startDate: () => {
      const now = new Date();
      const sixMonthsAgo = new Date();
      sixMonthsAgo.setMonth(now.getMonth() - 6);
      return sixMonthsAgo.toISOString().split('T')[0];
    },
    endDate: () => new Date().toISOString().split('T')[0]
  },
  {
    name: "Kansas City",
    model: "xweather",
    parameter: "storm_reports",
    coordinates: [-94.5786, 39.0997],
    zoom: 10,
    polygon: {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [[
          [-94.8, 38.9],
          [-94.3, 38.9],
          [-94.3, 39.3],
          [-94.8, 39.3],
          [-94.8, 38.9]
        ]]
      }
    },
    startDate: () => "2000-01-01",
    endDate: () => new Date().toISOString().split('T')[0]
  }
];

export async function initializeDemoSearches(userId: string) {
  try {
    // Check if user already has demo searches
    const { data: existing } = await supabase
      .from('saved_searches')
      .select('name')
      .eq('user_id', userId);

    if (existing && existing.length > 0) {
      return; // User already has saved searches
    }

    // Insert demo locations as saved searches
    const { error } = await supabase
      .from('saved_searches')
      .insert(
        demoLocations.map(loc => ({
          user_id: userId,
          name: loc.name,
          model: loc.model,
          parameter: loc.parameter,
          start_date: loc.startDate(),
          end_date: loc.endDate(),
          polygon: loc.polygon
        }))
      );

    if (error) throw error;
  } catch (error) {
    console.error('Error initializing demo searches:', error);
  }
}